export interface IUnitNodeSavePermission {
    code: string;
    level: number;
    levelA: number; //Additional permission A
    levelB: number; //Additional permission B
    levelC: number; //Additional permission C
    type: number;
    companyIds: string[]; //Partner Company Ids
}

export class UnitNodeSavePermission implements IUnitNodeSavePermission {
    code: string;
    level: number;
    levelA: number; //Additional permission A
    levelB: number; //Additional permission B
    levelC: number; //Additional permission C
    type: number;
    companyIds: string[]; //Partner Company Ids

    constructor();
    constructor(obj: IUnitNodeSavePermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
        this.levelA = obj && obj.levelA || 0;
        this.levelB = obj && obj.levelB || 0;
        this.levelC = obj && obj.levelC || 0;
        this.type = obj && obj.type || 0;
        this.companyIds = obj && obj.companyIds || [];
    }
}